import React, { useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
  Radio,
} from "@mui/material";
// components

import moment from "moment";
import Iconify from "../iconify";
import { patch } from "src/utils/networkUtils";

export const PrizeStatus = {
  0: "Draft",
  1: "Active",
  2: "Closed",
};

const ActivePrizeDrawTable = ({ rows, handleOpenMenu }) => {
  const [selectedRows, setSelectedRows] = useState({});

  const handleOnChange = async (event, rowId, status) => {
    try {
      const resp = await patch(`/admin/raffles/${rowId}/status`, {
        status,
      });
      if (resp.success) {
        window.location.reload(true);
      }
    } catch (error) {
      setSelectedRows((prev) => ({
        ...prev,
        [rowId]: !event.target.checked,
      }));
    }
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Entries</TableCell>
            <TableCell>In Draft</TableCell>
            <TableCell>In Complete</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(
            (row, index) =>
              row !== null &&
              row !== undefined && (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.raffleId}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.title_en}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.startDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.closeDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {PrizeStatus[row?.status]}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.entriesCount}
                  </TableCell>
                  <TableCell>
                    <Radio
                      checked={!!selectedRows[row.raffleId]}
                      onChange={(e) => handleOnChange(e, row.raffleId, 0)}
                      size="small"
                      sx={{ padding: 0.5 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Radio
                      checked={!!selectedRows[row.raffleId]}
                      onChange={(e) => handleOnChange(e, row.raffleId, 2)}
                      size="small"
                      sx={{ padding: 0.5 }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(event) => {
                        handleOpenMenu(event, row);
                      }}
                      id={row.raffleId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActivePrizeDrawTable;
